export interface UserPrinter {
  id: string;
  userId: string;
  userName: string;
  printerId: string;
  printerName: string;
  printerAddress: string;
}
